<template>
  <div
    class="search-config--badge"
    v-if="value"
    :class="{
      'search-config--badge-error': isOmitted,
    }"
  >
    <span class="txtov" :title="snakeCaseToWords(searchKey)">{{ value }}</span>
    <div class="dt-icon-container" @click="onDelete">
      <img class="dt-icon v5 s0" src="static/icons/close-icon.svg" alt />
    </div>
  </div>
</template>

<script>
import { snakeCaseToWords } from "../../utility";

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    searchKey: {
      type: String,
      required: true,
    },
    isOmitted: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    snakeCaseToWords: snakeCaseToWords,
    onDelete() {
      this.$emit("delete", this.searchKey);
    },
  },
};
</script>

<style lang="scss">
.search-config--badge {
  margin-top: auto;
  margin-bottom: auto;

  /* margin-left: 4px; */
  margin-right: 6px;

  background-color: var(--bc-850);
  padding: 3px 4px 3px 10px;
  border-radius: 12px;

  display: flex;

  &.search-config--badge-error {
    background-color: var(--chroma-950);
  }

  span {
    display: flex;
    flex-direction: column;
    justify-content: center;

    margin-right: 4px;
  }
}
</style>